import { dataEyeBrightSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconEyeBrightSolid = /*#__PURE__*/createIcon(dataEyeBrightSolid)
export default IconEyeBrightSolid
